export const getBracketsAppRedirectURL = (
	tourneyId: string,
	activityId: string,
	statusId: number,
	currentSequence: number,
	bracketFormatId: number,
	currentSequencePoolId: string,
	totalPools: number
) => {
	const url = new URL(`https://brackets.${process.env.NEXT_PUBLIC_REWRITE_DOMAIN_NAME}/tournaments/${tourneyId}/events/${activityId}`).toString();

	if (statusId === 3) {
		return `${url}/standings`;
	}

	if (currentSequence > 1 || [1, 2].includes(bracketFormatId)) {
		return `${url}/elimination/${currentSequencePoolId}`;
	}

	if (bracketFormatId === 4 && totalPools > 1) {
		return `${url}/overview`;
	}

	if (bracketFormatId === 4 && totalPools === 1) {
		return `${url}/pools/${currentSequencePoolId}`;
	}

	return `${url}/overview`;
};
